import {Button, Typography} from '@yandex-delivery/blocks'
import {useFormValue} from '@yandex-delivery/nlf-form/v2'
import clsx from 'clsx'
import {useCallback} from 'react'
import type {PollQuestion, PollQuestionAnswer} from 'src/api'

import {classes} from './Answer.classes'
import type {FormType} from './Form.types'

export type AnswerProps = {
  answer: PollQuestionAnswer
  handleAnswerClick: (question: PollQuestion, answer: PollQuestionAnswer) => void
  question: PollQuestion
}

export function Answer({answer, handleAnswerClick, question}: AnswerProps): React.ReactElement<AnswerProps> {
  const onAnswerClick = useCallback(() => {
    handleAnswerClick(question, answer)
  }, [answer, handleAnswerClick, question])

  const poll = useFormValue<FormType, 'poll'>('poll') || {}
  const isAnswerSelected = (poll[question.id] || []).some(value => value === answer.id)

  return (
    <Button
      className={clsx(isAnswerSelected && classes.selected)}
      onPress={onAnswerClick}
      px="s"
      size="xs"
      variant="default"
    >
      <Typography
        color={isAnswerSelected ? 'invert' : 'main'}
        group="tight"
        thickness="regular"
        variant="caption1"
        whiteSpace="nowrap"
      >
        {answer.text}
      </Typography>
    </Button>
  )
}
